/**
 * @module components/YAxisSetting/YAxisName
 * @description Y 轴名称输入 — 固定读写 yAxisName
 */
import React, { useCallback } from 'react';
import { useIntl } from 'umi';
import { Input } from 'tea-component';
import { useSettingState } from '../../context';

const YAxisName: React.FC = () => {
  const { formatMessage } = useIntl();
  const { value, setValue } = useSettingState('yAxisName');

  const handleChange = useCallback(
    (newValue: string) => {
      setValue(newValue);
    },
    [setValue],
  );

  return (
    <div className="dbl-chart-setting-row">
      <span className="dbl-lable-gray-font">
        {formatMessage({ id: 'dbl_chart_primary_name' })}
      </span>
      <Input
        className="dbl-chart-setting-row__input"
        value={value}
        onChange={handleChange}
        placeholder={formatMessage({
          id: 'dbl_chart_primary_basic_info_optional',
        })}
      />
    </div>
  );
};

export default React.memo(YAxisName);
